import {
  OnboardingStackParamList,
  OnboardingStackRouteName,
} from 'features/navigation/navigators/OnboardingStackNavigator/types'

export function getOnboardingPropConfig<Screen extends OnboardingStackRouteName>(
  screen: Screen,
  params?: OnboardingStackParamList[Screen]
): {
  screen: 'OnboardingStackNavigator'
  params?: {
    screen: Screen
    params?: OnboardingStackParamList[Screen]
  }
} {
  return {
    screen: 'OnboardingStackNavigator',
    params: { screen, params },
  }
}
